/**
 * Shared threshold for "Google is disapproving enough of the catalogue to be
 * worth flagging on the UI" (NEA-5921). One value, two consumers today —
 * the Inventory tab's ConnectionStatusCard and the Google channel manage
 * page's ChannelSyncStatus — so they agree on when a card flips amber.
 *
 * A single rejected product on a 400-item feed (0.25%) does not warrant a
 * warning treatment; ≥30% does.
 */

export const GOOGLE_DISAPPROVAL_THRESHOLD = 0.3;

/**
 * Share of GMC-tracked products Google is currently disapproving. Returns 0
 * (not null) when no GMC data is available so callers can compare against the
 * threshold without a null-guard. The denominator is what *Google* tracks
 * (active + disapproved + expiring + pending) — not the shop's full
 * catalogue — so the percentage reads as "of what we sent Google, X% is
 * rejected".
 */
export function googleDisapprovalRate(stats) {
	if (!stats) return 0;
	const active = stats.active ?? 0;
	const disapproved = stats.disapproved ?? 0;
	const expiring = stats.expiring ?? 0;
	const pending = stats.pending ?? 0;
	const tracked = active + disapproved + expiring + pending;
	if (tracked <= 0) return 0;
	return disapproved / tracked;
}
